export default __webpack_public_path__ + "static/media/18g30mmwb.c19ec50d.jpeg";